export const features = [
  {
    id: 1,
    title: 'Image downloads',
    isOn: true,
    category: 'Usage',
    planIds: ['MONTH_FREE'],
  },
  {
    id: 2,
    title: 'Unlimited 3D downloads',
    isOn: true,
    category: 'Usage',
    planIds: ['MONTH_POPULAR'],
  },
  {
    id: 3,
    title: 'Generator library',
    isOn: true,
    category: 'Usage',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 4,
    title: 'Spawn & edit with AI',
    isOn: { MONTH_FREE: true, MONTH_POPULAR: true },
    category: 'Usage',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 5,
    title: 'Themed materials',
    isOn: true,
    category: 'Usage',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 6,
    title: 'Image-to-3D',
    isOn: true,
    category: 'Usage',
    planIds: ['MONTH_POPULAR'],
  },
  {
    id: 7,
    title: 'API metered billing',
    isOn: { ENTERPRISE: true },
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },

  {
    id: 8,
    title: 'Unlimited downloads & Projects',
    isOn: true,
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 9,
    title: 'Private generators',
    isOn: true,
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 10,
    title: 'SDK',
    isOn: true,
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 11,
    title: 'Game engine plug-in',
    isOn: true,
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 12,
    title: 'Priority support',
    isOn: true,
    category: 'Usage',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 13,
    title: 'API Access',
    isOn: { MONTH_FREE: false, MONTH_POPULAR: true },
    category: 'Usage',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 14,
    title: 'Create with AI',
    isOn: true,
    category: 'AI',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 15,
    title: 'Edit with AI',
    isOn: true,
    category: 'AI',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 16,
    title: 'Texture with AI',
    isOn: false,
    category: 'AI',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 17,
    title: 'Custom colors with AI',
    isOn: false,
    category: 'AI',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 18,
    title: 'Personal use',
    isOn: true,
    category: 'License',
    planIds: ['MONTH_FREE'],
  },
  {
    id: 19,
    title: 'Commercial use (attribution)',
    isOn: true,
    category: 'License',
    planIds: ['MONTH_POPULAR'],
  },
  {
    id: 20,
    title: 'Commercial use',
    isOn: false,
    category: 'License',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 21,
    title: 'Redistribution & reselling',
    isOn: { MONTH_FREE: false, MONTH_POPULAR: false },
    category: 'License',
    planIds: ['MONTH_FREE', 'MONTH_POPULAR'],
  },
  {
    id: 22,
    title: 'Selling on marketplaces',
    isOn: false,
    category: 'License',
    planIds: ['MONTH_POPULAR'],
  },
  {
    id: 23,
    title: 'Synthetic data for AI training',
    isOn: true,
    category: 'Custom license for',
    planIds: ['ENTERPRISE'],
  },
  {
    id: 24,
    title: 'Commercial 3D printing',
    isOn: true,
    category: 'Custom license for',
    planIds: ['ENTERPRISE'],
  },
];
export const pricingData = [
  {
    id: 'MONTH_FREE',
    title: 'Starter',
    // previousPrice: '4.99',
    // price: '0.99',
    description: 'Try for free',
    disabled: false,
    categories: ['Usage', 'License'],
    CTA: '',
    dbPlanId: 'free',
  },
  {
    id: 'MONTH_POPULAR',
    title: 'Plus',
    previousPrice: '15.00',
    price: '4.99',
    priceColor: 'white',
    description: 'Unlimited downloads',
    highlight: true,
    prefix: 'for the first two months',
    categories: ['Usage', 'License'],
    CTA: 'Choose Plan',
    dbPlanId: 'popular',
  },
  {
    id: 'ENTERPRISE',
    title: 'Enterprise',
    altPrice: 'Contact Us',
    description: 'Custom solutions',
    // prefix: 'All features of Pro +',
    CTA: 'Contact Us',
    email: 'support@sloyd.ai',
    categories: ['Usage', 'Custom license for'],
  },
];
